import { buildJobColumns } from '../components/build-job-columns';
import { useCustomerFilterOptions } from '../public/use-customer-filter-options';
import { useJobCatalogues } from '../../../hooks/use-job-catalogues';
import { useJobList } from './use-job-list';

/** JobsPage's own state: the columns built from the list's filters and catalogues. */
export function useJobsPage() {
  const jobs = useJobList();
  const customerOptions = useCustomerFilterOptions();
  const catalogues = useJobCatalogues();

  const jobTypeOptions = catalogues.status === 'loaded' ? catalogues.jobTypes.map((jobType) => ({ value: jobType.code, label: jobType.name })) : [];
  const columns = buildJobColumns({ customerOptions, jobTypeOptions, list: jobs.list });

  return { jobs, columns };
}
